import React from "react";
import { Button, Form, Icon, Input} from "semantic-ui-react";
import shop from "shop/shop"
import { observer } from "mobx-react";
import { useHistory } from 'react-router-dom';

function CouponInput({ label, defaultValue="", defaultActive= false}) {
  const [active, setActive] = React.useState( defaultActive )
  const [couponCode, setCouponCode] = React.useState( defaultValue )
  const { activeCoupons } = shop.cart
  const hasCoupons = activeCoupons.length > 0
  const history = useHistory();

  return <React.Fragment><Form
    onSubmit={
      async () => {
        let ok = await shop.cart.postCoupons( couponCode )
        if ( ok ) {
          

          //document.location.reload()
          shop.cart.hydrate()
          shop.cart.update()
          const delay = ms => new Promise(
            resolve => setTimeout(resolve, ms)
            );
          await delay( 500 )
          
          //document.location.reload()
        if(history.location.pathname !== "/quickorder/"){
            history.push("/checkout/deliveryCpn/")
        }
        }
        else{
          document.location.reload()
        }
      }
    }
    className={"CouponInput"}>
    {!hasCoupons && <div>
      {!active && <Button basic fluid onClick={() => {
        setActive( true )
      }
      }>
        <div className="flex flex-row justify-between">
          <div>Coupons</div>
          <div><Icon name={"question circle outline"}/></div>
        </div>
      </Button>
      }
      {active && <React.Fragment>
        {label &&  <label>{label}</label>}
        <div className="pb1">
          <Input
            value={couponCode}
            onChange={( e ) => {
              setCouponCode( e.currentTarget.value )
              
            }
            } size={"small"} fluid/>
        </div>
        <Button
          type={"submit"}
          fluid size={"small"} primary>Aktivieren</Button>
      </React.Fragment>}
    </div>}
    
    <div className="activeCoupons pt2">
      {activeCoupons
        .map( ( code, index ) => {
          return <div key={`${index}-${code}`} className="pa1 ph3 ba b--black-10 f6 tc mb1 flex flex-row justify-between">
            {code}
            <Icon name={"check circle"}/>
          </div>
        } )}

    </div>
  </Form>
  {shop.cart.data.giftcards && shop.cart.data.giftcards[0] && <Button className="w-100" onClick={
                async () => {
        let ok = await shop.cart.postCoupons( "deleteCoupon" )
        if ( ok ) {
          

          //document.location.reload()
          shop.cart.hydrate()
          shop.cart.update()
          const delay = ms => new Promise(
            resolve => setTimeout(resolve, ms)
            );
          await delay( 500 )
          
          //document.location.reload()
        if(history.location.pathname !== "/quickorder/"){
            history.push("/checkout/deliveryCpn/")
        }
        }
        else{
          document.location.reload()
        }
      }}>
        Code entfernen
        </Button>}
  </React.Fragment>
}


export default observer( CouponInput )


// WEBPACK FOOTER //
// ./src/theme/base/components/Cart/CouponInput.js